import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpParams,
  HttpRequest
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CustomerDataService } from '../services/customer-data.service';

/** Pass untouched request through to the next request handler. */
@Injectable()
export class HeaderInterceptor implements HttpInterceptor {
  constructor(private customerDataService: CustomerDataService) {}
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const excludeInterceptor = req.params.get('exclude-interceptor') === 'true';

    if (!excludeInterceptor) {
      const reqWithHeaders = req.clone({
        setHeaders: {
          'x-adl-document-type':
            this.customerDataService.customerData.documentType,
          'x-adl-document-number':
            this.customerDataService.customerData.numberDNI,
          'transaction-id': this.customerDataService.customerData.transactionId,
          'x-adl-channel': 'bavv-pasivo-cdt-masivo'
        }
      });

      return next.handle(reqWithHeaders);
    } else {
      const modifiedRequest = req.clone();
      const params: HttpParams = modifiedRequest.params;
      const updatedParams = params.delete('exclude-interceptor');
      return next.handle(modifiedRequest.clone({ params: updatedParams }));
    }
  }
}
